import api from "../../api/axios.instance"

export const registerUser = async (data) => {
    try {
        const response = await api.post('register-user', data)
        return response
    } catch (error) {
        return error
    }
}